/**
 * Formatting for the agent's approval_summary.needs_review_reason.
 *
 * The validation agents emit a snake_case reason token when a decision is
 * needs_review / escalate (e.g. "entity_linkage_undetermined",
 * "external_lookup_unavailable", "ambiguous_4j_approver_location"). Reviewer
 * surfaces render it so an escalation is never shown without its cause.
 */

/**
 * Turn a raw reason token into a human-readable label.
 * Returns '' for null/undefined/empty so callers can guard rendering.
 * @param {string|null|undefined} reason
 * @returns {string}
 */
export function formatNeedsReviewReason(reason) {
  if (!reason || typeof reason !== 'string') {
    return '';
  }
  return reason.trim().replace(/_/g, ' ');
}
